import React, { Component } from "react";
import {
  Card,
  Tabs,
  List,
  Input,
  Button,
  Typography,
  Radio,
  Divider,
  message,
  Tag,
  notification,
  Checkbox,
  Alert,
  Modal,
} from "antd";
import { QuestionCircleOutlined, SmileOutlined } from "@ant-design/icons";

import { connect } from "react-redux";
import {
  req_single_gqm_graduatealumni,
  req_add_gqm_graduateYearSurvey,
  req_edit_ams_alumni,
  req_single_ams_alumni,
} from "../../api";
import storageUtils from "../../utils/storageUtils";
import "./survey-common-year.css";
import AdumniModifyModal from "./alumni-modify-modal";

const { TabPane } = Tabs;
const { Title, Link, Text, Paragraph } = Typography;

class SurveyFirstYear extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    version: "115.04修正",
    yearSurvey: "1",
    testYear: "", //112
    participantId: "",
    participantName: "",
    tabPosition: "left",
    tabActive: "OO",
    investigations: [
      {
        sortvalue: 0,
        tabname: "說明",
        label: "OO",
        answertype: "text",
        answerlimit: 1,
        question: "流向追蹤問卷調查",
        description: "",
        answer: "",
        supplementanswer: "",
        selffill: "",
        disabled: true,
      },
      {
        sortvalue: 1,
        tabname: "題目1",
        label: "AA",
        answertype: "singlechoice",
        answerlimit: 1,
        question:
          "您目前的工作狀況為何（不包括留職停薪、育嬰假，請依主要薪水來源作答）？",
        description:
          "（同時為「全職工作者與部分工時者」，請以最主要工作狀況填報以下問項）",
        answer: "-1",
        detailsanswer: "",
        selffill: "",
        disabled: false,
      },
      {
        sortvalue: 2,
        tabname: "題目2",
        label: "AB",
        answertype: "singlechoice",
        answerlimit: 1,
        question: "您現在工作職業類型為何？",
        description: "",
        answer: "-1",
        supplementanswer: "",
        selffill: "",
        disabled: false,
      },
      {
        sortvalue: 3,
        tabname: "題目3",
        label: "AC",
        answertype: "singlechoice",
        answerlimit: 1,
        question: "您畢業後花了多久時間找到第1份工作？",
        description:
          "（若為創業者，請填答畢業後之創業時間；自由工作者，則以第1份穩定工作時間為主）",
        answer: "-1",
        supplementanswer: "",
        selffill: "",
        disabled: false,
      },
      {
        sortvalue: 4,
        tabname: "題目4",
        label: "AD",
        answertype: "singlechoice",
        answerlimit: 1,
        question: "您現在工作平均每月收入為何？",
        description:
          "(請回答課稅前固定（經常）性收入，係指固定津貼、交通費、膳食費、水電費、按月發放之工作（生產、績效、業績）獎金及全勤獎金等)",
        answer: "-1",
        supplementanswer: "",
        selffill: "",
        disabled: false,
      },
      {
        sortvalue: 5,
        tabname: "題目5",
        label: "AE",
        answertype: "singlechoice",
        answerlimit: 1,
        question: "請問您現在主要的工作所在地點為何？",
        description: "",
        answer: "-1",
        supplementanswer: "",
        selffill: "",
        disabled: false,
      },
      {
        sortvalue: 6,
        tabname: "題目6",
        label: "AF",
        answertype: "singlechoice",
        answerlimit: 1,
        question: "您目前未就業的原因為何？",
        description: "",
        answer: "-1",
        supplementanswer: "",
        selffill: "",
        disabled: false,
      },
      {
        sortvalue: 7,
        tabname: "題目7",
        label: "AG",
        answertype: "singlechoice",
        answerlimit: 1,
        question: "您目前所具備的專業能力與工作所要求的相符程度為何？",
        description: "",
        answer: "-1",
        supplementanswer: "",
        selffill: "",
        disabled: false,
      },
      {
        sortvalue: 8,
        tabname: "題目8",
        label: "AH",
        answertype: "singlechoice",
        answerlimit: 1,
        question: "您目前的工作內容，是否需要具備專業證照？",
        description: "",
        answer: "-1",
        supplementanswer: "",
        selffill: "",
        disabled: false,
      },
      {
        sortvalue: 9,
        tabname: "題目9",
        label: "AI",
        answertype: "singlechoice",
        answerlimit: 1,
        question: "您對目前工作的整體滿意度為何？",
        description: "",
        answer: "-1",
        supplementanswer: "",
        selffill: "",
        disabled: false,
      },
      {
        sortvalue: 10,
        tabname: "題目10",
        label: "AJ",
        answertype: "singlechoice",
        answerlimit: 1,
        question:
          "您目前的工作內容與原就讀系、所、學位學程之專業訓練課程，其相符程度為何？",
        description: "",
        answer: "-1",
        supplementanswer: "",
        selffill: "",
        disabled: false,
      },
      {
        sortvalue: 11,
        tabname: "題目11",
        label: "AK",
        answertype: "manychoice",
        answerlimit: 3,
        question: "您在學期間以下哪些「學習經驗」對於現在工作有所幫助？",
        description: "(可複選，至多3項)",
        answer: [],
        supplementanswer: "",
        selffill: "",
        disabled: false,
      },
      {
        sortvalue: 12,
        tabname: "題目12",
        label: "AL",
        answertype: "singlechoice",
        answerlimit: 1,
        question:
          "您是否為了工作或自我生涯發展從事進修或考試，提升自我專業能力？",
        description: "",
        answer: "-1",
        supplementanswer: "",
        selffill: "",
        disabled: false,
      },
      {
        sortvalue: 13,
        tabname: "題目13",
        label: "AM",
        answertype: "manychoice",
        answerlimit: 3,
        question: "最常參與過學校哪些職涯活動或就業服務的幫助？",
        description: "(可複選，至多3項)",
        answer: [],
        supplementanswer: "",
        selffill: "",
        disabled: false,
      },
      {
        sortvalue: 14,
        tabname: "結束",
        label: "AN",
        answertype: "text",
        answerlimit: 1,
        question: "謝謝您的填答",
        description: "",
        answer: "",
        supplementanswer: "",
        selffill: "",
        disabled: true,
        pagepath: [{ choosepath: "default", uppage: "", nextpage: "" }],
      },
    ],
    surveys: [
      {
        label: "AA",
        children: [
          {
            scopevalue: "1A",
            keyvalue: 1,
            groupvalue: "A",
            content: "企業（包括民營企業或國營企業…等）",
            choicevalue: "1A1",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1A",
            keyvalue: 2,
            groupvalue: "A",
            content: "政府部門（包括職業軍人）",
            choicevalue: "1A2",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1A",
            keyvalue: 3,
            groupvalue: "A",
            content: "學校（包括公立及私立大學、高中、高職、國中小…等）",
            choicevalue: "1A3",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1A",
            keyvalue: 4,
            groupvalue: "A",
            content: "非營利機構",
            choicevalue: "1A4",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1A",
            keyvalue: 5,
            groupvalue: "A",
            content: "創業",
            choicevalue: "1A5",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1A",
            keyvalue: 6,
            groupvalue: "A",
            content: "自由工作者(以接案維生或個人服務，例如撰稿人…)",
            choicevalue: "1A6",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1A",
            keyvalue: 7,
            groupvalue: "A",
            content: "其他",
            choicevalue: "1A7",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1A",
            keyvalue: 8,
            groupvalue: "B1",
            content: "請問您1週工作時數約",
            choicevalue: "1A8",
            canselffill: "Y",
            selffilldescription: "小時",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1A",
            keyvalue: 9,
            groupvalue: "B2",
            content: "企業（包括民營企業或國營企業…等）",
            choicevalue: "1A9",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1A",
            keyvalue: 10,
            groupvalue: "B2",
            content: "政府部門（包括職業軍人）",
            choicevalue: "1A10",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1A",
            keyvalue: 11,
            groupvalue: "B2",
            content: "學校（包括公立及私立大學、高中、高職、國中小…等）",
            choicevalue: "1A11",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1A",
            keyvalue: 12,
            groupvalue: "B2",
            content: "非營利機構",
            choicevalue: "1A12",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1A",
            keyvalue: 13,
            groupvalue: "B2",
            content: "創業",
            choicevalue: "1A13",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1A",
            keyvalue: 14,
            groupvalue: "B2",
            content: "自由工作者(以接案維生或個人服務，例如撰稿人…)",
            choicevalue: "1A14",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1A",
            keyvalue: 15,
            groupvalue: "B2",
            content: "其他",
            choicevalue: "1A15",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1A",
            keyvalue: 16,
            groupvalue: "C",
            content: "家管/料理家務者",
            choicevalue: "1A16",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1A",
            keyvalue: 17,
            groupvalue: "D",
            content: "目前非就業中",
            choicevalue: "1A17",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
        ],
      },
      {
        label: "AB",
        children: [
          {
            scopevalue: "1B",
            keyvalue: 1,
            groupvalue: "default",
            content: "建築營造類",
            choicevalue: "1B1",
            canselffill: "N",
            selffilldescription: "",
            details: ["建築規劃設計", "營造及維護"],
            description:
              "針對建築物及其實質環境，進行生產及作業之調查測量、規劃、組織、指導、協調、管制及考核等管理，並代辦申請建築許可、拆除執照、招商投標、擬定施工契約及其他工程上接洽事項之相關建築或營造工作。",
            version: "115.04修正",
          },
          {
            scopevalue: "1B",
            keyvalue: 2,
            groupvalue: "default",
            content: "製造類",
            choicevalue: "1B2",
            canselffill: "N",
            selffilldescription: "",
            details: [
              "生產管理",
              "製程研發",
              "設備安裝維護",
              "品質管理",
              "資材及庫存規劃",
              "工業安全管理",
            ],
            description:
              "規劃、執行、組織、指導、協調、管制及考核從原料、中間階段到最終產品的製作流程、相關的專業性及技術性的活動，例如生產計畫與控制、維護和製造／加工工程、品質管理、存貨管理等。",
            version: "115.04修正",
          },
          {
            scopevalue: "1B",
            keyvalue: 3,
            groupvalue: "default",
            content: "科學、技術、工程、數學類",
            canselffill: "N",
            selffilldescription: "",
            choicevalue: "1B3",
            details: ["工程及技術", "數學及科學"],
            description:
              "規劃、管理及提供科學（如物理科學、社會科學、工程、數學等）研究和專業技術（如實驗、測試及研發等）服務。",
            version: "115.04修正",
          },
          {
            scopevalue: "1B",
            keyvalue: 4,
            groupvalue: "default",
            content: "物流運輸類",
            choicevalue: "1B4",
            canselffill: "N",
            selffilldescription: "",
            details: [
              "運輸作業",
              "物流規劃及管理",
              "運輸工程",
              "運輸規劃及管理",
            ],
            description:
              "將物料或產品從生產處移轉到消費者或使用者的流程管理，包含規劃、執行與管制各項採購、進貨、儲存控制、檢驗、搬運、配銷、運輸（利用公路、航空、鐵路、及水路，對於人、材料及產品的運送做適度的規劃和調控），並從事相關設備的維修工作。",
          },
          {
            scopevalue: "1B",
            keyvalue: 5,
            groupvalue: "default",
            content: "天然資源、食品與農業類",
            choicevalue: "1B5",
            canselffill: "N",
            selffilldescription: "",
            details: [
              "食品生產與加工",
              "植物研究發展與應用",
              "動物研究發展與應用",
              "自然資源保育",
              "環境保護與衛生",
              "農業經營",
            ],
            description:
              "凡在農、林、漁、牧業從事生產及作業之規劃、指導及協調，針對農、林、畜、水產品原料進行調理後冷凍、製罐、脫水、醃燻製、保藏加工及產銷配送之用等工作；以及從事生物學理在動植物方面的應用發展研究，並進行保護、改善與利用自然生態環境資源之工作，以確保人類生存環境，使自然資源能永續不斷，提高經濟或社會利益。",
            version: "115.04修正",
          },
          {
            scopevalue: "1B",
            keyvalue: 6,
            groupvalue: "default",
            content: "醫療保健類",
            choicevalue: "1B6",
            canselffill: "N",
            selffilldescription: "",
            details: [
              "醫療服務",
              "長期照護服務",
              "公共衛生",
              "健康產業及醫務管理",
              "生技研發",
            ],
            description:
              "從事人類所患各種常見疾病及損傷之例行檢查、診斷和施行各種治療或急救處置或照護，應用預防醫學知識技術及生物科學知識，進行健康檢查、疾病預防、衛生指導與生物科技、中草藥生物技術、藥用化妝品產品研發，並妥善規劃及管理醫療單位，以促進全民健康。",
            version: "115.04修正",
          },
          {
            scopevalue: "1B",
            keyvalue: 7,
            groupvalue: "default",
            content: "藝文與影音傳播類",
            choicevalue: "1B7",
            canselffill: "N",
            selffilldescription: "",
            details: [
              "影視傳播",
              "印刷出版",
              "視覺藝術",
              "表演藝術",
              "新聞傳播",
              "通訊傳播",
              "設計產業",
            ],
            description:
              "規劃設計、製作、展出表演和出版藝文及影音相關作品，包括視覺設計、通訊傳播、表演藝術、印刷出版、新聞電視廣播及電影、包裝說明、工藝設計等。",
            version: "115.04修正",
          },
          {
            scopevalue: "1B",
            keyvalue: 8,
            groupvalue: "default",
            content: "資訊科技類",
            choicevalue: "1B8",
            canselffill: "N",
            selffilldescription: "",
            details: [
              "網路規劃與建置管理",
              "資訊支援與服務",
              "數位內容與傳播",
              "軟體開發及程式設計",
            ],
            description:
              "從事網際網路系統或資訊軟硬體、程式語言、多媒體、公用軟體及相關周邊設備之設計、製作、修改、測試、安裝及系統整合，並提供維修及障礙排除等支援服務。",
            version: "115.04修正",
          },
          {
            scopevalue: "1B",
            keyvalue: 9,
            groupvalue: "default",
            content: "金融財務類",
            choicevalue: "1B9",
            canselffill: "N",
            selffilldescription: "",
            details: ["證券及投資", "財務", "銀行金融業務", "保險", "會計"],
            description:
              "凡在金融、保險、不動產業及一般企業或組織，從事客戶服務活動作業及組織內部財務業務之規劃、組織、指導、協調、管制及考核。",
            version: "115.04修正",
          },
          {
            scopevalue: "1B",
            keyvalue: 10,
            groupvalue: "default",
            content: "企業經營管理類",
            choicevalue: "1B10",
            canselffill: "N",
            selffilldescription: "",
            details: [
              "一般管理",
              "企業資訊管理",
              "人力資源管理",
              "運籌管理",
              "行政支援",
            ],
            description:
              "利用規劃、組織、領導及控制等功能，針對企業內的財務、行銷、人事、生產物料、機器設備及技術等有限資源做妥善的安排，以發揮企業功能及生產力，使組織可以有效的運作。",
            version: "115.04修正",
          },
          {
            scopevalue: "1B",
            keyvalue: 11,
            groupvalue: "default",
            content: "行銷與銷售類",
            choicevalue: "1B11",
            canselffill: "N",
            selffilldescription: "",
            details: [
              "行銷管理",
              "專業銷售",
              "行銷傳播",
              "市場分析研究",
              "零售與通路管理",
            ],
            description:
              "企業或組織內從事行銷業務或行銷活動之規劃、執行、組織、協調、指導、管制及考核，以及針對從生產者到消費者的訊息分析進行整合，以達到組織目標。",
            version: "115.04修正",
          },
          {
            scopevalue: "1B",
            keyvalue: 12,
            groupvalue: "default",
            content: "政府公共事務類",
            choicevalue: "1B12",
            canselffill: "N",
            selffilldescription: "",
            details: ["國防", "外交與國際事務", "公共行政"],
            description:
              "執行政府功能，包括國家和地方各層級的管理、國家安全、外交、規劃、稅收、法規及地方行政管理。",
            version: "115.04修正",
          },
          {
            scopevalue: "1B",
            keyvalue: 13,
            groupvalue: "default",
            content: "教育與訓練類",
            choicevalue: "1B13",
            canselffill: "N",
            selffilldescription: "",
            details: ["教育行政", "教學"],
            description:
              "評估內外在環境、資源，規劃符合教學組織需求的目標，推動與發展相關業務或校務，並依據組織的目標及學習者的需求，配合各種教學理論、工具與策略，規劃適切、有效的教學活動及學習計畫。",
            version: "115.04修正",
          },
          {
            scopevalue: "1B",
            keyvalue: 14,
            groupvalue: "default",
            content: "個人及社會服務類",
            choicevalue: "1B14",
            canselffill: "N",
            selffilldescription: "",
            details: [
              "學前照護及教育",
              "心理諮商服務",
              "社會工作服務",
              "個人照護服務",
            ],
            description:
              "針對社會、家庭、個人及學齡前的幼童，提供心理及生理的專業性照護與服務，提升其生活品質與身心的健康與福祉。",
            version: "115.04修正",
          },
          {
            scopevalue: "1B",
            keyvalue: 15,
            groupvalue: "default",
            content: "休閒與觀光旅遊類",
            choicevalue: "1B15",
            canselffill: "N",
            selffilldescription: "",
            details: ["餐飲管理", "旅館管理", "旅遊管理", "休閒遊憩管理"],
            description:
              "從事旅遊及休閒活動相關之服務，包含顧客、商業團體旅程及組團之旅遊行程規劃、代辦出國及簽證手續、安排食宿、交通工具；或接待、引導旅客觀光旅遊，提供適當解說及服務；在旅館等場所接待旅客，於其到達、居留及離開時給予服務及管理、提供餐飲服務或其他休閒、健身指導行業之工作。",
            version: "115.04修正",
          },
          {
            scopevalue: "1B",
            keyvalue: 16,
            groupvalue: "default",
            content: "司法、法律與公共安全類",
            choicevalue: "1B16",
            canselffill: "N",
            selffilldescription: "",
            details: ["司法", "公共安全", "法律服務"],
            description:
              "從事與法律、公共安全與確保民眾生命及財產等相關之專業和技術的服務，包含受當事人之委託或依法令之規定，執行律師職務或處理法律事務之人員；預防火災並搶救災害及緊急救護；實際執行警察勤務、偵查刑事案件、督導管理矯正機關之收容人。",
            version: "115.04修正",
          },
        ],
      },
      {
        label: "AC",
        children: [
          {
            scopevalue: "1C",
            keyvalue: 1,
            groupvalue: "default",
            content: "約1個月內",
            choicevalue: "1C1",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1C",
            keyvalue: 1,
            groupvalue: "default",
            content: "約1個月以上至2個月內",
            choicevalue: "1C2",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1C",
            keyvalue: 1,
            groupvalue: "default",
            content: "約2個月以上至3個月內",
            choicevalue: "1C3",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1C",
            keyvalue: 1,
            groupvalue: "default",
            content: "約3個月以上至4個月內",
            choicevalue: "1C4",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1C",
            keyvalue: 1,
            groupvalue: "default",
            content: "約4個月以上至6個月內",
            choicevalue: "1C5",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1C",
            keyvalue: 1,
            groupvalue: "default",
            content: "約6個月以上",
            choicevalue: "1C6",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1C",
            keyvalue: 1,
            groupvalue: "default",
            content: "畢業前已有專職工作",
            choicevalue: "1C7",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
        ],
      },
      {
        label: "AD",
        children: [
          {
            scopevalue: "1D",
            keyvalue: 1,
            groupvalue: "default",
            content: "約新臺幣22,000元以下",
            choicevalue: "1D1",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1D",
            keyvalue: 2,
            groupvalue: "default",
            content: "約新臺幣22,001元至25,000元",
            choicevalue: "1D2",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1D",
            keyvalue: 3,
            groupvalue: "default",
            content: "約新臺幣25,001元至28,000元",
            choicevalue: "1D3",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1D",
            keyvalue: 4,
            groupvalue: "default",
            content: "約新臺幣28,001元至31,000元",
            choicevalue: "1D4",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1D",
            keyvalue: 5,
            groupvalue: "default",
            content: "約新臺幣31,001元至34,000元",
            choicevalue: "1D5",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1D",
            keyvalue: 6,
            groupvalue: "default",
            content: "約新臺幣34,001元至37,000元",
            choicevalue: "1D6",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1D",
            keyvalue: 7,
            groupvalue: "default",
            content: "約新臺幣37,001元至40,000元",
            choicevalue: "1D7",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1D",
            keyvalue: 8,
            groupvalue: "default",
            content: "約新臺幣40,001元至43,000元",
            choicevalue: "1D8",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1D",
            keyvalue: 9,
            groupvalue: "default",
            content: "約新臺幣43,001元至46,000元",
            choicevalue: "1D9",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1D",
            keyvalue: 10,
            groupvalue: "default",
            content: "約新臺幣46,001元至49,000元",
            choicevalue: "1D10",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1D",
            keyvalue: 11,
            groupvalue: "default",
            content: "約新臺幣49,001元至52,000元",
            choicevalue: "1D11",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1D",
            keyvalue: 12,
            groupvalue: "default",
            content: "約新臺幣52,001元至55,000元",
            choicevalue: "1D12",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1D",
            keyvalue: 13,
            groupvalue: "default",
            content: "約新臺幣55,001元至60,000元",
            choicevalue: "1D13",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1D",
            keyvalue: 14,
            groupvalue: "default",
            content: "約新臺幣60,001元至65,000元",
            choicevalue: "1D14",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1D",
            keyvalue: 15,
            groupvalue: "default",
            content: "約新臺幣65,001元至70,000元",
            choicevalue: "1D15",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1D",
            keyvalue: 16,
            groupvalue: "default",
            content: "約新臺幣70,001元至75,000元",
            choicevalue: "1D16",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1D",
            keyvalue: 17,
            groupvalue: "default",
            content: "約新臺幣75,001元至80,000元",
            choicevalue: "1D17",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1D",
            keyvalue: 18,
            groupvalue: "default",
            content: "約新臺幣80,001元至85,000元",
            choicevalue: "1D18",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1D",
            keyvalue: 19,
            groupvalue: "default",
            content: "約新臺幣85,001元至90,000元",
            choicevalue: "1D19",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1D",
            keyvalue: 20,
            groupvalue: "default",
            content: "約新臺幣90,001元至95,000元",
            choicevalue: "1D20",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1D",
            keyvalue: 21,
            groupvalue: "default",
            content: "約新臺幣95,001元至100,000元",
            choicevalue: "1D21",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1D",
            keyvalue: 22,
            groupvalue: "default",
            content: "約新臺幣100,001元至110,000元",
            choicevalue: "1D22",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1D",
            keyvalue: 23,
            groupvalue: "default",
            content: "約新臺幣110,001元至120,000元",
            choicevalue: "1D23",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1D",
            keyvalue: 24,
            groupvalue: "default",
            content: "約新臺幣120,001元至130,000元",
            choicevalue: "1D24",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1D",
            keyvalue: 25,
            groupvalue: "default",
            content: "約新臺幣130,001元至140,000元",
            choicevalue: "1D25",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1D",
            keyvalue: 26,
            groupvalue: "default",
            content: "約新臺幣140,001元至150,000元",
            choicevalue: "1D26",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1D",
            keyvalue: 27,
            groupvalue: "default",
            content: "約新臺幣150,001元至170,000元",
            choicevalue: "1D27",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1D",
            keyvalue: 28,
            groupvalue: "default",
            content: "約新臺幣170,001元至190,000元",
            choicevalue: "1D28",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1D",
            keyvalue: 29,
            groupvalue: "default",
            content: "約新臺幣190,001元至210,000元",
            choicevalue: "1D29",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1D",
            keyvalue: 30,
            groupvalue: "default",
            content: "約新臺幣210,001元以上",
            choicevalue: "1D30",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
        ],
      },
      {
        label: "AE",
        children: [
          {
            scopevalue: "1E",
            keyvalue: 1,
            groupvalue: "A",
            content: "基隆市",
            choicevalue: "1E1",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1E",
            keyvalue: 2,
            groupvalue: "A",
            content: "新北市",
            choicevalue: "1E2",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1E",
            keyvalue: 3,
            groupvalue: "A",
            content: "台北市",
            choicevalue: "1E3",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1E",
            keyvalue: 4,
            groupvalue: "A",
            content: "桃園市",
            choicevalue: "1E4",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1E",
            keyvalue: 5,
            groupvalue: "A",
            content: "新竹縣",
            choicevalue: "1E5",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1E",
            keyvalue: 6,
            groupvalue: "A",
            content: "新竹市",
            choicevalue: "1E6",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1E",
            keyvalue: 7,
            groupvalue: "A",
            content: "苗栗縣",
            choicevalue: "1E7",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1E",
            keyvalue: 8,
            groupvalue: "B",
            content: "台中市",
            choicevalue: "1E8",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1E",
            keyvalue: 9,
            groupvalue: "B",
            content: "南投縣",
            choicevalue: "1E9",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1E",
            keyvalue: 10,
            groupvalue: "B",
            content: "彰化縣",
            choicevalue: "1E10",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1E",
            keyvalue: 11,
            groupvalue: "B",
            content: "雲林縣",
            choicevalue: "1E11",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1E",
            keyvalue: 12,
            groupvalue: "B",
            content: "嘉義縣",
            choicevalue: "1E12",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1E",
            keyvalue: 13,
            groupvalue: "B",
            content: "嘉義市",
            choicevalue: "1E13",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1E",
            keyvalue: 14,
            groupvalue: "C",
            content: "台南市",
            choicevalue: "1E14",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1E",
            keyvalue: 15,
            groupvalue: "C",
            content: "高雄市",
            choicevalue: "1E15",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1E",
            keyvalue: 16,
            groupvalue: "C",
            content: "屏東縣",
            choicevalue: "1E16",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1E",
            keyvalue: 17,
            groupvalue: "D",
            content: "台東縣",
            choicevalue: "1E17",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1E",
            keyvalue: 18,
            groupvalue: "D",
            content: "花蓮縣",
            choicevalue: "1E18",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1E",
            keyvalue: 19,
            groupvalue: "D",
            content: "宜蘭縣",
            choicevalue: "1E19",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1E",
            keyvalue: 20,
            groupvalue: "D",
            content: "連江縣",
            choicevalue: "1E20",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1E",
            keyvalue: 21,
            groupvalue: "D",
            content: "金門縣",
            choicevalue: "1E21",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1E",
            keyvalue: 22,
            groupvalue: "D",
            content: "澎湖縣",
            choicevalue: "1E22",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1E",
            keyvalue: 23,
            groupvalue: "E",
            content: "亞洲（香港、澳門、大陸地區）",
            choicevalue: "1E24",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1E",
            keyvalue: 24,
            groupvalue: "E",
            content: "亞洲（香港、澳門、大陸地區以外國家）",
            choicevalue: "1E25",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1E",
            keyvalue: 25,
            groupvalue: "E",
            content: "大洋洲",
            choicevalue: "1E26",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1E",
            keyvalue: 26,
            groupvalue: "E",
            content: "非洲",
            choicevalue: "1E27",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1E",
            keyvalue: 27,
            groupvalue: "E",
            content: "歐洲",
            choicevalue: "1E28",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1E",
            keyvalue: 28,
            groupvalue: "E",
            content: "北美洲",
            choicevalue: "1E29",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1E",
            keyvalue: 29,
            groupvalue: "E",
            content: "中美洲",
            choicevalue: "1E30",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1E",
            keyvalue: 30,
            groupvalue: "E",
            content: "南美洲",
            choicevalue: "1E31",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
        ],
      },
      {
        label: "AF",
        children: [
          {
            scopevalue: "1F",
            keyvalue: 1,
            groupvalue: "A",
            content: "進修中",
            choicevalue: "1F1",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1F",
            keyvalue: 2,
            groupvalue: "B",
            content: "服役中或等待服役中",
            choicevalue: "1F2",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1F",
            keyvalue: 3,
            groupvalue: "C",
            content: "國內研究所",
            choicevalue: "1F3",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1F",
            keyvalue: 4,
            groupvalue: "C",
            content: "出國留學",
            choicevalue: "1F4",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1F",
            keyvalue: 5,
            groupvalue: "C",
            content: "證照",
            choicevalue: "1F5",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1F",
            keyvalue: 6,
            groupvalue: "C",
            content: "公務人員",
            choicevalue: "1F6",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1F",
            keyvalue: 7,
            groupvalue: "C",
            content: "其他",
            choicevalue: "1F7",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1F",
            keyvalue: 8,
            groupvalue: "D1",
            content: "沒有工作機會",
            choicevalue: "1F8",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1F",
            keyvalue: 9,
            groupvalue: "D1",
            content: "薪水不滿意",
            choicevalue: "1F9",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1F",
            keyvalue: 11,
            groupvalue: "D1",
            content: "公司財務或制度不穩健",
            choicevalue: "1F10",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1F",
            keyvalue: 12,
            groupvalue: "D1",
            content: "工作地點不適合",
            choicevalue: "1F11",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1F",
            keyvalue: 13,
            groupvalue: "D1",
            content: "與所學不符",
            choicevalue: "1F12",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1F",
            keyvalue: 14,
            groupvalue: "D1",
            content: "不符合家人的期望",
            choicevalue: "1F13",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1F",
            keyvalue: 15,
            groupvalue: "D1",
            content: "工作內容不滿意",
            choicevalue: "1F14",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1F",
            keyvalue: 16,
            groupvalue: "D1",
            content: "其他",
            choicevalue: "1F22",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1F",
            keyvalue: 17,
            groupvalue: "D2",
            content: "約1個月以內",
            choicevalue: "1F15",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1F",
            keyvalue: 18,
            groupvalue: "D2",
            content: "約1個月以上至2個月內",
            choicevalue: "1F16",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1F",
            keyvalue: 19,
            groupvalue: "D2",
            content: "約2個月以上至3個月內",
            choicevalue: "1F17",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1F",
            keyvalue: 21,
            groupvalue: "D2",
            content: "約3個月以上至4個月內",
            choicevalue: "1F18",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1F",
            keyvalue: 22,
            groupvalue: "D2",
            content: "約4個月以上至6個月內",
            choicevalue: "1F19",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1F",
            keyvalue: 23,
            groupvalue: "D2",
            content: "約6個月以上",
            choicevalue: "1F20",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1F",
            keyvalue: 24,
            groupvalue: "E",
            content: "不想找工作、生病…",
            choicevalue: "1F21",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
        ],
      },
      {
        label: "AG",
        children: [
          {
            scopevalue: "1G",
            keyvalue: 1,
            groupvalue: "default",
            content: "非常符合",
            choicevalue: "1G1",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1G",
            keyvalue: 2,
            groupvalue: "default",
            content: "符合",
            choicevalue: "1G2",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1G",
            keyvalue: 3,
            groupvalue: "default",
            content: "普通",
            choicevalue: "1G3",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1G",
            keyvalue: 4,
            groupvalue: "default",
            content: "不符合",
            choicevalue: "1G4",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1G",
            keyvalue: 5,
            groupvalue: "default",
            content: "非常不符合",
            choicevalue: "1G5",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
        ],
      },
      {
        label: "AH",
        children: [
          {
            scopevalue: "1H",
            keyvalue: 1,
            groupvalue: "default",
            content: "需要",
            choicevalue: "1H1",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1H",
            keyvalue: 2,
            groupvalue: "default",
            content: "不需要",
            choicevalue: "1H2",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
        ],
      },
      {
        label: "AI",
        children: [
          {
            scopevalue: "1I",
            keyvalue: 1,
            groupvalue: "default",
            content: "非常滿意",
            choicevalue: "1I1",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1I",
            keyvalue: 2,
            groupvalue: "default",
            content: "滿意",
            choicevalue: "1I2",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1I",
            keyvalue: 3,
            groupvalue: "default",
            content: "普通",
            choicevalue: "1I3",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1I",
            keyvalue: 4,
            groupvalue: "default",
            content: "不滿意",
            choicevalue: "1I4",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1I",
            keyvalue: 5,
            groupvalue: "default",
            content: "非常不滿意",
            choicevalue: "1I5",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
        ],
      },
      {
        label: "AJ",
        children: [
          {
            scopevalue: "1J",
            keyvalue: 1,
            groupvalue: "default",
            content: "非常符合",
            choicevalue: "1J1",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1J",
            keyvalue: 2,
            groupvalue: "default",
            content: "符合",
            choicevalue: "1J2",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1J",
            keyvalue: 3,
            groupvalue: "default",
            content: "普通",
            choicevalue: "1J3",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1J",
            keyvalue: 4,
            groupvalue: "default",
            content: "不符合",
            choicevalue: "1J4",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1J",
            keyvalue: 5,
            groupvalue: "default",
            content: "非常不符合",
            choicevalue: "1J5",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
        ],
      },
      {
        label: "AK",
        children: [
          {
            scopevalue: "1K",
            keyvalue: 1,
            groupvalue: "default",
            content: "專業知識、知能傳授",
            choicevalue: "1K1",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1K",
            keyvalue: 2,
            groupvalue: "default",
            content: "建立同學及老師人脈",
            choicevalue: "1K2",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1K",
            keyvalue: 3,
            groupvalue: "default",
            content: "校內實務課程",
            choicevalue: "1K3",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1K",
            keyvalue: 4,
            groupvalue: "default",
            content: "校外業界實習",
            choicevalue: "1K4",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1K",
            keyvalue: 5,
            groupvalue: "default",
            content: "社團活動",
            choicevalue: "1K5",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1K",
            keyvalue: 6,
            groupvalue: "default",
            content: "語言學習",
            choicevalue: "1K6",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1K",
            keyvalue: 7,
            groupvalue: "default",
            content: "參與國際交流活動",
            choicevalue: "1K7",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1K",
            keyvalue: 8,
            groupvalue: "default",
            content: "志工服務、服務學習",
            choicevalue: "1K8",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1K",
            keyvalue: 9,
            groupvalue: "default",
            content: "擔任研究或教學助理",
            choicevalue: "1K9",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1K",
            keyvalue: 10,
            groupvalue: "default",
            content: "其他訓練",
            choicevalue: "1K10",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
        ],
      },
      {
        label: "AL",
        children: [
          {
            scopevalue: "1L",
            keyvalue: 1,
            groupvalue: "A1",
            content: "國內大專校院進修",
            choicevalue: "1L1",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1L",
            keyvalue: 2,
            groupvalue: "A1",
            content: "出國進修",
            choicevalue: "1L2",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1L",
            keyvalue: 3,
            groupvalue: "A2",
            content: "國家考試",
            choicevalue: "1L3",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1L",
            keyvalue: 4,
            groupvalue: "A2",
            content: "技術士證照",
            choicevalue: "1L4",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1L",
            keyvalue: 5,
            groupvalue: "A2",
            content: "金融證照",
            choicevalue: "1L5",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1L",
            keyvalue: 6,
            groupvalue: "A2",
            content: "教師證",
            choicevalue: "1L6",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1L",
            keyvalue: 7,
            groupvalue: "A2",
            content: "語言證照",
            choicevalue: "1L7",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1L",
            keyvalue: 8,
            groupvalue: "A2",
            content: "電腦認證",
            choicevalue: "1L8",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1L",
            keyvalue: 9,
            groupvalue: "A3",
            content: "其他 ",
            choicevalue: "1L9",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1L",
            keyvalue: 10,
            groupvalue: "B",
            content: "沒有",
            choicevalue: "1L10",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
        ],
      },
      {
        label: "AM",
        children: [
          {
            scopevalue: "1M",
            keyvalue: 1,
            groupvalue: "default",
            content: "大專校院就業職能平台(UCAN)",
            choicevalue: "1M1",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1M",
            keyvalue: 2,
            groupvalue: "default",
            content: "職涯諮詢、就業諮詢",
            choicevalue: "1M2",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1M",
            keyvalue: 3,
            groupvalue: "default",
            content: "職涯發展課程(演講)及活動",
            choicevalue: "1M3",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1M",
            keyvalue: 4,
            groupvalue: "default",
            content: "業界實習、參訪",
            choicevalue: "1M4",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1M",
            keyvalue: 5,
            groupvalue: "default",
            content: "企業徵才說明會",
            choicevalue: "1M5",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1M",
            keyvalue: 6,
            groupvalue: "default",
            content: "校園企業徵才博覽會",
            choicevalue: "1M6",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1M",
            keyvalue: 7,
            groupvalue: "default",
            content: "定期工作訊息",
            choicevalue: "1M7",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1M",
            keyvalue: 8,
            groupvalue: "default",
            content: "校內工讀",
            choicevalue: "1M8",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1M",
            keyvalue: 9,
            groupvalue: "default",
            content: "校外工讀",
            choicevalue: "1M9",
            canselffill: "N",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
          {
            scopevalue: "1M",
            keyvalue: 10,
            groupvalue: "default",
            content: "其他",
            choicevalue: "1M10",
            canselffill: "Y",
            selffilldescription: "",
            details: [],
            description: "",
            version: "115.04修正",
          },
        ],
      },
    ],
    isWork: false,
    item: {},
    employer: {
      TwId: "",
      NowStatusModifyOperator: "",
      QuestionnaireSurveyOperator: "",
      JobType: "",
      JobCompany: "",
      JobDepartment: "",
      JobTitle: "",
      JobTelephone: "",
      JobAddress: "",
      JobFax: "",
      JobFirstSalary: "0",
      CurrentSalary: "0",
      JobBossName: "",
      JobBossEmail: "",
      NowStatusSource: "自行異動",
      NowStatusPrimary: "就業",
      NowStatusSecondary: "就業",
      condition: "JOBBYTWID",
    },
    isLocked: true,
    isShowEditAlumniInfoModal: false,
  };

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
  }

  UNSAFE_componentWillMount() {
    this.api_single_row();
    window.removeEventListener("resize", this.resize.bind(this));
  }

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_add_row = async (reply) => {
    const item = reply;
    const { token, userCode, userName } = this.props.user;
    // 填單為自己
    item.RecordCreateOperator = userCode + ";" + userName;
    item.ActualCounselorCode = "";
    item.ActualCounselorName = "";

    const result = await req_add_gqm_graduateYearSurvey(item, token);

    if (result.status === "success") {
      // message.success(result.message)
      message.success("問卷完成，謝謝您配合");
    } else {
      message.error(result.message);
    }
  };

  api_single_row = async () => {
    const { token, userCode } = this.props.user;
    const { yearSurvey } = this.state;
    const result = await req_single_gqm_graduatealumni(
      userCode,
      yearSurvey,
      token
    );

    if (result) {
      //有數據-判斷是否已經做完問卷
      if (result.NumFirstYearSurvey > 0) {
        notification.open({
          message: "提示",
          description:
            "親愛的校友您好，您已經填寫過本問卷，若重填僅會覆蓋前一次結果",
          icon: <SmileOutlined style={{ color: "#108ee9" }} />,
        });
        this.init_values(result);
      } else {
        this.init_values(result);
      }
    } else {
      //沒數據-目前非納入調查範圍
    }

    // 取得校友基本資料
    const alumni = await req_single_ams_alumni(userCode, token);
    const item = alumni;
    this.setState({ item });
  };

  api_edit_item = async (item) => {
    const result = await req_edit_ams_alumni(
      item,
      storageUtils.getUser().token
    );
    if (result.status === "success") {
      // console.log(result)
      message.success(result.message);
    } else {
      message.error(result.message);
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_values = (item) => {
    // console.log(this.props.alumni)
    const { YearGrade, StudentId, StudentName } = item;
    this.setState({
      testYear: YearGrade,
      participantId: StudentId,
      participantName: StudentName,
    });
  };

  handle_set_value = (num, field, value) => {
    let items = [...this.state.investigations];
    let index = items.findIndex((element) => element.label === num);
    let item = { ...items[index] };
    switch (field) {
      case "answer":
        item.answer = value;
        break;
      case "supplementanswer":
        item.supplementanswer = value;
        break;
      case "disabled":
        item.disabled = value;
        break;
      case "selffill":
        item.selffill = value;
        break;
      default:
    }
    items[index] = item;
    this.setState({ investigations: items });
    //console.log(this.state.investigations)
  };

  handle_get_value = (num, field) => {
    let value = "";
    let items = [...this.state.investigations];
    let index = items.findIndex((element) => element.label === num);
    let item = { ...items[index] };
    switch (field) {
      case "answer":
        value = item.answer;
        break;
      case "supplementanswer":
        value = item.supplementanswer;
        break;
      case "selffill":
        value = item.selffill;
        break;
      default:
    }
    return value;
  };

  handle_get_surveys_content = (questioncode, choicevalue) => {
    ///console.log(questioncode, choicevalue)
    let value = "";
    let items = [...this.state.surveys];
    let index = items.findIndex((element) => element.label === questioncode);
    let options = [...items[index].children];
    //console.log('options:', options)
    let selected = options.findIndex(
      (element) => element.choicevalue === choicevalue
    );
    let item = { ...options[selected] };
    //console.log('item:', item)
    value = item.content;
    //console.log('value:', value)
    return value;
  };

  get_list_options = (label) => {
    const data = this.state.surveys.find((item, index) => {
      return item.label === label ? true : false;
    });
    return data.children;
  };

  handle_reply_verification = () => {
    //console.log(items)
    const yearSurvey = this.state.yearSurvey;
    const year = this.state.testYear;
    const version = this.state.version;
    const alumniCode = this.state.participantId;
    const alumniName = this.state.participantName;

    const alumnireply = {
      Version: "",

      YearSurvey: "",
      YearGrade: "",

      AlumniCode: "",
      AlumniName: "",
      RecordCreateOperator: "",

      QuestionAA: "",
      AnswerAA: "",
      ValueAA: "",

      QuestionAB: "",
      AnswerAB: "",
      ValueAB: "",

      QuestionAC: "",
      AnswerAC: "",
      ValueAC: "",

      QuestionAD: "",
      AnswerAD: "",
      ValueAD: "",

      QuestionAE: "",
      AnswerAE: "",
      ValueAE: "",

      QuestionAF: "",
      AnswerAF: "",
      ValueAF: "",

      QuestionAG: "",
      AnswerAG: "",
      ValueAG: "",

      QuestionAH: "",
      AnswerAH: "",
      ValueAH: "",

      QuestionAI: "",
      AnswerAI: "",
      ValueAI: "",

      QuestionAJ: "",
      AnswerAJ: "",
      ValueAJ: "",

      QuestionAK: "",
      AnswerAK: "",
      ValueAK: "",

      QuestionAL: "",
      AnswerAL: "",
      ValueAL: "",

      QuestionAM: "",
      AnswerAM: "",
      ValueAM: "",

      QuestionAN: "",
      AnswerAN: "",
      ValueAN: "",
    };
    alumnireply.YearSurvey = yearSurvey;
    alumnireply.YearGrade = year;
    alumnireply.Version = version;
    alumnireply.AlumniCode = alumniCode;
    alumnireply.AlumniName = alumniName;

    this.state.investigations.forEach((item, i, array) => {
      //console.log(item, i, array);
      alumnireply["Question" + item["label"]] = item.question;
      switch (item["label"]) {
        case "AA":
          if (
            item.answer === "1A9" ||
            item.answer === "1A10" ||
            item.answer === "1A11" ||
            item.answer === "1A12" ||
            item.answer === "1A13" ||
            item.answer === "1A14"
          ) {
            alumnireply["Value" + item["label"]] =
              year + "1A8;" + item.supplementanswer + "@" + year + item.answer;
          } else if (item.answer === "1A15") {
            alumnireply["Value" + item["label"]] =
              year +
              "1A8;" +
              item.supplementanswer +
              "@" +
              year +
              item.answer +
              ";" +
              item.selffill;
          } else if (item.answer === "1A7") {
            alumnireply["Value" + item["label"]] =
              year + item.answer + ";" + item.selffill;
          } else {
            alumnireply["Value" + item["label"]] = year + item.answer;
          }
          alumnireply["Answer" + item["label"]] =
            this.handle_get_surveys_content(item["label"], item.answer) || "";
          break;
        case "AB":
        case "AD":
        case "AG":
        case "AH":
        case "AI":
        case "AJ":
          alumnireply["Value" + item["label"]] = year + item.answer;
          alumnireply["Answer" + item["label"]] =
            this.handle_get_surveys_content(item["label"], item.answer) || "";
          break;
        case "AC":
        case "AE":
        case "AL":
          if (
            item.answer === "1C6" ||
            item.answer === "1E23" ||
            item.answer === "1E24" ||
            item.answer === "1E25" ||
            item.answer === "1E26" ||
            item.answer === "1E27" ||
            item.answer === "1E28" ||
            item.answer === "1E29" ||
            item.answer === "1E30" ||
            item.answer === "1L9"
          ) {
            alumnireply["Value" + item["label"]] =
              year + item.answer + ";" + item.selffill;
          } else {
            alumnireply["Value" + item["label"]] = year + item.answer;
          }
          alumnireply["Answer" + item["label"]] =
            this.handle_get_surveys_content(item["label"], item.answer) || "";
          break;
        case "AF":
          if (
            item.answer === "1F8" ||
            item.answer === "1F9" ||
            item.answer === "1F10" ||
            item.answer === "1F11" ||
            item.answer === "1F12" ||
            item.answer === "1F13" ||
            item.answer === "1F14" ||
            item.answer === "1F22"
          ) {
            if (item.answer === "1F22") {
              alumnireply["Value" + item["label"]] =
                year +
                item.answer +
                ";" +
                item.selffill +
                "@" +
                year +
                item.supplementanswer;
            } else {
              alumnireply["Value" + item["label"]] =
                year + item.answer + "@" + year + item.supplementanswer;
            }
          } else {
            if (item.answer === "1F7" || item.answer === "1F21") {
              alumnireply["Value" + item["label"]] =
                year + item.answer + ";" + item.selffill;
            } else {
              alumnireply["Value" + item["label"]] = year + item.answer;
            }
          }
          alumnireply["Answer" + item["label"]] =
            this.handle_get_surveys_content(item["label"], item.answer) || "";
          break;
        case "AK":
        case "AM":
          if (item.answer.length > 0) {
            if (
              item.answer.indexOf("1K10") > -1 ||
              item.answer.indexOf("1M10") > -1
            ) {
              alumnireply["Value" + item["label"]] =
                item.answer
                  .map((element) => {
                    return year + element;
                  })
                  .sort((a, b) => {
                    var numA = parseInt(a.substring(5), 10);
                    var numB = parseInt(b.substring(5), 10);
                    if (numA < numB) {
                      return -1;
                    }
                    if (numA > numB) {
                      return 1;
                    }
                    return 0;
                  })
                  .join("@") +
                ";" +
                item.selffill;
              alumnireply["Answer" + item["label"]] = item.answer
                .map((element) => {
                  return this.handle_get_surveys_content(
                    item["label"],
                    element
                  );
                })
                .join(";");
            } else {
              alumnireply["Value" + item["label"]] = item.answer
                .map((element) => {
                  return year + element;
                })
                .join("@");
              alumnireply["Answer" + item["label"]] = item.answer
                .map((element) => {
                  return this.handle_get_surveys_content(
                    item["label"],
                    element
                  );
                })
                .join(";");
            }
          }
          break;
        default:
      }
    });

    Object.keys(alumnireply).forEach((key) => {
      if (alumnireply[key] === year + "-1") {
        alumnireply[key] = "";
      }
    });

    if (this.state.investigations[1]["answer"] === "1A16") {
      Object.keys(alumnireply).forEach((key) => {
        if (key.indexOf("Value") > -1) {
          if (key === "ValueAA" || key === "ValueAM") {
          } else {
            alumnireply[key] = "";
          }
        }
      });
    } else if (this.state.investigations[1]["answer"] === "1A17") {
      Object.keys(alumnireply).forEach((key) => {
        if (key.indexOf("Value") > -1) {
          if (key === "ValueAA" || key === "ValueAF" || key === "ValueAM") {
          } else {
            alumnireply[key] = "";
          }
        }
      });
    } else {
      Object.keys(alumnireply).forEach((key) => {
        if (key.indexOf("Value") > -1) {
          if (key === "ValueAF") {
            alumnireply[key] = "";
          }
        }
      });
    }
    this.api_add_row(alumnireply);
    //console.log(alumnireply)
  };

  handle_ui_edit_base = () => {
    this.setState({ isShowEditAlumniInfoModal: true });
  };
  // 操作互動處理 //////////////////////////////////////////////

  handle_ui_tab_process = (currentPage, value) => {
    var nextPage = currentPage;
    switch (currentPage) {
      case "OO":
        nextPage = "AA";
        this.setState({ tabActive: nextPage });
        break;
      case "AA": //Page1 START
        // 題1 **[目前非就業中] 先跳題6再跳題13 / ** [家管/料理家務者] 跳題13
        switch (value) {
          case "1A16":
            nextPage = "AM"; //第13題
            this.setState({ tabActive: nextPage });
            this.setState({ isWork: false });
            break;
          case "1A17":
            nextPage = "AF"; //第6題
            this.setState({ tabActive: nextPage });
            this.setState({ isWork: false });
            break;
          default:
            if (value !== "-1") {
              // 選擇[其他]
              if (value === "1A7" || value === "1A15") {
                let data = this.handle_get_value(currentPage, "selffill");
                //console.log(data)
                if (data.replace(/(^[\s]*)|([\s]*$)/g, "") === "") {
                  message.info("請在[其他]欄中輸入說明");
                } else {
                  nextPage = "AB";
                  this.setState({ tabActive: nextPage });
                }
                this.setState({ isWork: false });
              } else {
                // 選擇[就業]

                // 選擇[部分工時]
                if (
                  value === "1A9" ||
                  value === "1A10" ||
                  value === "1A11" ||
                  value === "1A12" ||
                  value === "1A13" ||
                  value === "1A14"
                ) {
                  if (this.handle_get_value(currentPage, "supplementanswer")) {
                    nextPage = "AB";
                    this.setState({ tabActive: nextPage });
                  } else {
                    message.info("請在每週總工時");
                  }
                } else {
                  nextPage = "AB";
                  this.setState({ tabActive: nextPage });
                }
                this.setState({ isWork: true });
              }
            } else {
              message.info("未選擇任何答案");
            }
        }
        break;
      case "AB":
        if (value !== "-1") {
          nextPage = "AC";
          this.setState({ tabActive: nextPage });
        } else {
          message.info("未選擇任何答案");
        }
        break;
      case "AC":
        switch (value) {
          case "1C6":
            // 選擇[填充]
            let data = this.handle_get_value(currentPage, "selffill");
            //console.log(data)
            if (data.replace(/(^[\s]*)|([\s]*$)/g, "") === "") {
              message.info("請在空白欄中輸入說明");
            } else {
              nextPage = "AD";
              this.setState({ tabActive: nextPage });
            }
            break;
          default:
            if (value !== "-1") {
              nextPage = "AD";
              this.setState({ tabActive: nextPage });
            } else {
              message.info("未選擇任何答案");
            }
        }
        break;
      case "AD":
        if (value !== "-1") {
          nextPage = "AE";
          this.setState({ tabActive: nextPage });
        } else {
          message.info("未選擇任何答案");
        }
        break;
      case "AE":
        switch (value) {
          case "1E23":
          case "1E24":
          case "1E25":
          case "1E26":
          case "1E27":
          case "1E28":
          case "1E29":
          case "1E30":
            // 選擇[填充]
            let data = this.handle_get_value(currentPage, "selffill");
            //console.log(data)
            if (data.replace(/(^[\s]*)|([\s]*$)/g, "") === "") {
              message.info("請在空白欄中輸入國名");
            } else {
              nextPage = "AG";
              this.setState({ tabActive: nextPage });
            }
            break;
          default:
            if (value !== "-1") {
              nextPage = "AG";
              this.setState({ tabActive: nextPage });
            } else {
              message.info("未選擇任何答案");
            }
        }
        break;
      case "AF": // Page6
        if (value !== "-1") {
          switch (value) {
            case "1F8": //尋找工作中
            case "1F9":
            case "1F10":
            case "1F11":
            case "1F12":
            case "1F13":
            case "1F14":
            case "1F22":
              let supplementanswer = this.handle_get_value(
                currentPage,
                "supplementanswer"
              );
              if (supplementanswer === "") {
                message.info("請在[目前已花多久時間找工作]中選擇一項");
              } else {
                // 選擇[其他]
                if (value === "1F22") {
                  let data = this.handle_get_value(currentPage, "selffill");
                  //console.log(data)
                  if (data.replace(/(^[\s]*)|([\s]*$)/g, "") === "") {
                    message.info("請在[其他]欄中輸入說明");
                  } else {
                    nextPage = "AM";
                    this.setState({ tabActive: nextPage });
                  }
                } else {
                  nextPage = "AM";
                  this.setState({ tabActive: nextPage });
                }
              }
              break;
            default:
              // 選擇[其他]
              if (value === "1F7" || value === "1F21") {
                let data = this.handle_get_value(currentPage, "selffill");
                //console.log(data)
                if (data.replace(/(^[\s]*)|([\s]*$)/g, "") === "") {
                  message.info("請在[其他]欄中輸入說明");
                } else {
                  nextPage = "AM";
                  this.setState({ tabActive: nextPage });
                }
              } else {
                nextPage = "AM";
                this.setState({ tabActive: nextPage });
              }
          }
        } else {
          message.info("未選擇任何答案");
        }
        break;
      case "AG":
        if (value !== "-1") {
          nextPage = "AH";
          this.setState({ tabActive: nextPage });
        } else {
          message.info("未選擇任何答案");
        }

        break;
      case "AH":
        if (value !== "-1") {
          nextPage = "AI";
          this.setState({ tabActive: nextPage });
        } else {
          message.info("未選擇任何答案");
        }
        break;
      case "AI":
        if (value !== "-1") {
          nextPage = "AJ";
          this.setState({ tabActive: nextPage });
        } else {
          message.info("未選擇任何答案");
        }
        break;
      case "AJ":
        if (value !== "-1") {
          nextPage = "AK";
          this.setState({ tabActive: nextPage });
        } else {
          message.info("未選擇任何答案");
        }
        break;
      case "AK":
        // console.log(value)
        if (value.length === 0) {
          message.info("未選擇任何答案");
        } else if (value.length > 3) {
          message.info("超過3個選項");
        } else {
          // 選擇其他
          if (value.indexOf("1K10") > -1) {
            let data = this.handle_get_value(currentPage, "selffill");
            if (data.replace(/(^[\s]*)|([\s]*$)/g, "") === "") {
              message.info("請在[其他]中輸入說明");
            } else {
              nextPage = "AL";
              this.setState({ tabActive: nextPage });
            }
          } else {
            nextPage = "AL";
            this.setState({ tabActive: nextPage });
          }
        }
        break;
      case "AL":
        switch (value) {
          case "1L9":
            // 選擇[填充]
            let data = this.handle_get_value(currentPage, "selffill");
            //console.log(data)
            if (data.replace(/(^[\s]*)|([\s]*$)/g, "") === "") {
              message.info("請在空白欄中輸入說明");
            } else {
              nextPage = "AM";
              this.setState({ tabActive: nextPage });
            }
            break;
          default:
            if (value !== "-1") {
              nextPage = "AM";
              this.setState({ tabActive: nextPage });
            } else {
              message.info("未選擇任何答案");
            }
        }
        break;
      case "AM": //Page13 END
        if (value.length === 0) {
          message.info("未選擇任何答案");
        } else if (value.length > 3) {
          message.info("超過3個選項");
        } else {
          // 選擇其他
          if (value.indexOf("1M10") > -1) {
            let data = this.handle_get_value(currentPage, "selffill");
            if (data.replace(/(^[\s]*)|([\s]*$)/g, "") === "") {
              message.info("請在[其他]中輸入說明");
            } else {
              nextPage = "AN";
              this.setState({ tabActive: nextPage });
              this.handle_reply_verification();
            }
          } else {
            nextPage = "AN";
            this.setState({ tabActive: nextPage });
            this.handle_reply_verification();
          }
        }
        break;
      default:
      //  console.log(this.state.investigations)
    }

    // 跳頁設定
    // 將本頁關閉
    this.handle_set_value(currentPage, "disabled", false);
    // 將下頁開啟
    this.handle_set_value(this.state.tabActive, "disabled", true);
  };

  handle_ui_tab_jump = (upPage) => {
    this.setState({ tabActive: upPage });
  };

  handle_ui_reply = (question, e) => {
    //console.log(question)
    const num = question;
    const value = e.target.value;
    this.handle_set_value(num, "answer", value);
    //console.log(this.state.investigations)
  };

  handle_ui_field_process = (type, question_number, target_field, e) => {
    switch (type) {
      case "checkbox":
        this.handle_set_value(question_number, target_field, e);
        break;
      default:
        this.handle_set_value(question_number, target_field, e.target.value);
        break;
    }
  };

  handle_ui_open_notification = (content) => {
    notification.open({
      message: "描述說明",
      description: content,
      onClick: () => {
        //console.log('Notification Clicked!');
      },
    });
  };

  handleChange(event) {
    const { employer } = this.state;
    //console.log(event)
    Object.keys(employer).forEach((propertyName) => {
      if (event.target.id === "AgreePrivacy" && event.target.value !== null) {
        // Checkbox
        employer.AgreePrivacy = event.target.checked;
      } else {
        if (event.target.id === propertyName && event.target.value !== null) {
          employer[propertyName] = event.target.value.trim();
        }
      }
    });
    this.setState({ employer });
  }

  handleSubmit(event) {
    event.preventDefault();
    const row = this.state.employer;
    const errors = [];

    if (errors.length === 0) {
      row.TwId = this.state.item.TwId;
      row.NowStatusModifyOperator = storageUtils.getUser().userCode;
      row.NowStatusModifyOperator = storageUtils.getUser().userCode;
      row.NowStatusSource = "自行異動";
      row.condition = "JOBBYTWID";
      //console.log(row)
      this.api_edit_item(row);
      message.success("完成就業資訊回報，謝謝您的配合");
    } else {
      let info = errors.join(",");
      message.error(info);
    }
  }

  /////////////////////////////////////////////////////////////////////

  render() {
    const {
      item,
      testYear,
      tabPosition,
      tabActive,
      investigations,
      isWork,
      //isLocked,
      isShowEditAlumniInfoModal,
    } = this.state;
    const {
      JobType,
      JobCompany,
      JobDepartment,
      JobTitle,
      JobTelephone,
      JobAddress,
      JobFax,
      JobFirstSalary,
      CurrentSalary,
      JobBossName,
      JobBossEmail,
    } = this.state.employer;
    const radioStyle = {
      display: "block",
      height: "30px",
      lineHeight: "30px",
    };
    const otherstyles = {
      border: "1px",
      borderBottomStyle: "solid",
      borderTopStyle: "none",
      borderLeftStyle: "none",
      borderRightStyle: "none",
    };
    const options = this.get_list_options;

    return (
      <Card>
        {testYear !== "" ? (
          <Tabs
            tabPosition={tabPosition}
            defaultActiveKey="OO"
            activeKey={tabActive}
            size="small"
          >
            <TabPane
              tab={investigations[0]["tabname"]}
              key={investigations[0]["label"]}
              disabled={investigations[0]["disabled"]}
              style={{ width: "90%" }}
            >
              <List
                header={
                  <>
                    <Title level={4}>{investigations[0]["question"]}</Title>
                    <Text type="danger" underline>
                      {investigations[0]["description"]}
                    </Text>
                  </>
                }
                footer={
                  <>
                    {/* <p style={{ color: "blue" }}>
                      您好，問卷調查前，請先修訂您的基本資料
                    </p>
                    <Button
                      type="primary"
                      onClick={() => this.handle_ui_edit_base()}
                    >
                      基本資料修訂
                    </Button>
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_jump(investigations[1]["label"])
                      }
                      disabled={isLocked === true ? true : false}
                    >
                      問卷調查開始
                    </Button> */}
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_jump(investigations[1]["label"])
                      }
                    >
                      問卷調查開始
                    </Button>
                  </>
                }
              >
                <List.Item>
                  <Typography>
                    <Title>親愛的畢業校友，您好</Title>
                    <Paragraph>
                      大專畢業後一年的您，現況如何？母校十分關心您，希望瞭解您的現況與感想。本項調查結果將提供母校辦學及校務發展改善、系所學位學程課程規劃及高等教育人才培育相關政策研議之參考。
                    </Paragraph>
                    <Paragraph>
                      您的意見十分重要，懇請耐心協助填答。本調查不會影響您任何權益，但請勿轉由他人代為填答。母校由衷希望您能撥冗回覆本調查。
                      本問卷結果將依個人資料保護法規定嚴密保管與遵循法令規定處理，並提供以下單位進行後續運用，以及避免重複向您蒐集資料，敬請放心填答。
                    </Paragraph>
                    <Paragraph>
                      <ul>
                        <li>
                          <Text>提供教育部進行教育政策研議與分析…等事項。</Text>
                        </li>
                        <li>
                          <Text>
                            提供學校辦理教學改進、服務追蹤、資訊交流及未來校友服務…等事項。
                          </Text>
                        </li>
                      </ul>
                    </Paragraph>
                    <Paragraph>
                      如對本問卷填答有任何疑問或需依個人資料保護法第3條規定行使相關權利時，歡迎以E-Mail或電話與我們聯絡。感謝您的填答！
                    </Paragraph>
                    <Paragraph>
                      <ul>
                        <li>
                          <Text>
                            承辦單位：
                            <Link href="https://cds-rd.tut.edu.tw/">
                              研發處/職涯發展中心
                            </Link>
                          </Text>
                        </li>
                        <li>
                          <Text>
                            聯絡電話：
                            <Link href="TEL:06-2421971">
                            06-2421971
                            </Link>
                          </Text>
                        </li>
                        <li>
                          <Text>
                            E-Mail：
                            <Link href="mailto:emtalk@mail.tut.edu.tw">
                              emtalk@mail.tut.edu.tw
                            </Link>
                          </Text>
                        </li>
                      </ul>
                    </Paragraph>
                  </Typography>
                </List.Item>
              </List>
            </TabPane>
            <TabPane
              tab={investigations[1]["tabname"]}
              key={investigations[1]["label"]}
              disabled={investigations[1]["disabled"]}
              style={{ width: "90%" }}
            >
              <List
                header={
                  <>
                    <Title level={4}>{investigations[1]["question"]}</Title>
                    <Text type="danger" underline>
                      {investigations[1]["description"]}
                    </Text>
                  </>
                }
                footer={
                  <Button
                    type="primary"
                    onClick={() =>
                      this.handle_ui_tab_process(
                        investigations[1]["label"],
                        investigations[1]["answer"]
                      )
                    }
                  >
                    下一題
                  </Button>
                }
              >
                <List.Item>
                  <Radio.Group
                    onChange={(e) =>
                      this.handle_ui_field_process(
                        "radio",
                        investigations[1]["label"],
                        "answer",
                        e
                      )
                    }
                  >
                    <Divider orientation="left">A.全職工作</Divider>
                    {options(investigations[1]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "A") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={otherstyles}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[1]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                                key={index}
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                                key={index}
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                    <Divider orientation="left">B.部份工時</Divider>
                    {options(investigations[1]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "B1") {
                        return (
                          <p>
                            B.1.{item["content"]}
                            <Input
                              placeholder=""
                              style={Object.assign({}, otherstyles, {
                                width: "50px",
                              })}
                              onChange={(e) =>
                                this.handle_ui_field_process(
                                  "input",
                                  investigations[1]["label"],
                                  "supplementanswer",
                                  e
                                )
                              }
                              key={index}
                            />
                            小時<Text mark>(建議以每週平均時數填報)</Text>
                          </p>
                        );
                      } else {
                        return true;
                      }
                    })}
                    <Divider orientation="left"></Divider>
                    <p>
                      <Text disabled strong>
                        B.2.若同時有多份Part
                        Time工作，請以主要工作時數較長者作答
                      </Text>
                    </p>
                    {options(investigations[1]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "B2") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={otherstyles}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[1]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                                key={index}
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                                key={index}
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                    <Divider orientation="left">C.家管</Divider>
                    {options(investigations[1]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "C") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={otherstyles}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[1]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                                key={index}
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                                key={index}
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                    <Divider orientation="left">D.非就業</Divider>
                    {options(investigations[1]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "D") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={otherstyles}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[1]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                                key={index}
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                                key={index}
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                  </Radio.Group>
                </List.Item>
              </List>
            </TabPane>
            <TabPane
              tab={investigations[2]["tabname"]}
              key={investigations[2]["label"]}
              disabled={investigations[2]["disabled"]}
              style={{ width: "90%" }}
            >
              <List
                header={
                  <>
                    <Title level={4}>{investigations[2]["question"]}</Title>
                    <Text type="danger" underline>
                      {investigations[2]["description"]}
                    </Text>
                  </>
                }
                footer={
                  <>
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_jump(investigations[1]["label"])
                      }
                    >
                      上一題
                    </Button>{" "}
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_process(
                          investigations[2]["label"],
                          investigations[2]["answer"]
                        )
                      }
                    >
                      下一題
                    </Button>
                  </>
                }
              >
                <List.Item>
                  <Radio.Group
                    onChange={(e) =>
                      this.handle_ui_field_process(
                        "radio",
                        investigations[2]["label"],
                        "answer",
                        e
                      )
                    }
                  >
                    {options(investigations[2]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "default") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={otherstyles}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[2]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                                key={index}
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                                key={index}
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                  </Radio.Group>
                </List.Item>
              </List>
            </TabPane>
            <TabPane
              tab={investigations[3]["tabname"]}
              key={investigations[3]["label"]}
              disabled={investigations[3]["disabled"]}
              style={{ width: "90%" }}
            >
              <List
                header={
                  <>
                    <Title level={4}>{investigations[3]["question"]}</Title>
                    <Text type="danger" underline>
                      {investigations[3]["description"]}
                    </Text>
                  </>
                }
                footer={
                  <>
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_jump(investigations[2]["label"])
                      }
                    >
                      上一題
                    </Button>{" "}
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_process(
                          investigations[3]["label"],
                          investigations[3]["answer"]
                        )
                      }
                    >
                      下一題
                    </Button>
                  </>
                }
              >
                <List.Item>
                  <Radio.Group
                    onChange={(e) =>
                      this.handle_ui_field_process(
                        "radio",
                        investigations[3]["label"],
                        "answer",
                        e
                      )
                    }
                  >
                    {options(investigations[3]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "default") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <>
                                <Input
                                  placeholder="幾"
                                  style={Object.assign({}, otherstyles, {
                                    width: "50px",
                                  })}
                                  onChange={(e) =>
                                    this.handle_ui_field_process(
                                      "input",
                                      investigations[3]["label"],
                                      "selffill",
                                      e
                                    )
                                  }
                                  key={index}
                                />
                                月
                              </>
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                                key={index}
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                  </Radio.Group>
                </List.Item>
              </List>
            </TabPane>
            <TabPane
              tab={investigations[4]["tabname"]}
              key={investigations[4]["label"]}
              disabled={investigations[4]["disabled"]}
              style={{ width: "90%" }}
            >
              <List
                header={
                  <>
                    <Title level={4}>{investigations[4]["question"]}</Title>
                    <Text type="danger" underline>
                      {investigations[4]["description"]}
                    </Text>
                  </>
                }
                footer={
                  <>
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_jump(investigations[3]["label"])
                      }
                    >
                      上一題
                    </Button>{" "}
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_process(
                          investigations[4]["label"],
                          investigations[4]["answer"]
                        )
                      }
                    >
                      下一題
                    </Button>
                  </>
                }
              >
                <List.Item>
                  <Radio.Group
                    onChange={(e) =>
                      this.handle_ui_field_process(
                        "radio",
                        investigations[4]["label"],
                        "answer",
                        e
                      )
                    }
                  >
                    {options(investigations[4]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "default") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={otherstyles}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[4]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                                key={index}
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                                key={index}
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                  </Radio.Group>
                </List.Item>
              </List>
            </TabPane>
            <TabPane
              tab={investigations[5]["tabname"]}
              key={investigations[5]["label"]}
              disabled={investigations[5]["disabled"]}
              style={{ width: "90%" }}
            >
              <List
                header={
                  <>
                    <Title level={4}>{investigations[5]["question"]}</Title>
                    <Text type="danger" underline>
                      {investigations[5]["description"]}
                    </Text>
                  </>
                }
                footer={
                  <>
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_jump(investigations[4]["label"])
                      }
                    >
                      上一題
                    </Button>{" "}
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_process(
                          investigations[5]["label"],
                          investigations[5]["answer"]
                        )
                      }
                    >
                      下一題
                    </Button>
                  </>
                }
              >
                <List.Item>
                  <Radio.Group
                    onChange={(e) =>
                      this.handle_ui_field_process(
                        "radio",
                        investigations[5]["label"],
                        "answer",
                        e
                      )
                    }
                  >
                    <Divider orientation="left">境內</Divider>
                    <Title level={5}>
                      <p>
                        <Text type="secondary">北部地區</Text>
                      </p>
                    </Title>
                    {options(investigations[5]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "A") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="國名"
                                style={Object.assign({}, otherstyles, {
                                  width: "60px",
                                  height: "30px",
                                })}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[5]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                                key={index}
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                                key={index}
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                    <Divider orientation="left"></Divider>
                    <Title level={5}>
                      <p>
                        <Text type="secondary">中部地區</Text>
                      </p>
                    </Title>
                    {options(investigations[5]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "B") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="國名"
                                style={Object.assign({}, otherstyles, {
                                  width: "60px",
                                  height: "30px",
                                })}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[5]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                                key={index}
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                                key={index}
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                    <Divider orientation="left"></Divider>
                    <Title level={5}>
                      <p>
                        <Text type="secondary">南部地區</Text>
                      </p>
                    </Title>
                    {options(investigations[5]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "C") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="國名"
                                style={Object.assign({}, otherstyles, {
                                  width: "60px",
                                  height: "30px",
                                })}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[5]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                                key={index}
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                                key={index}
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                    <Divider orientation="left"></Divider>
                    <Title level={5}>
                      <p>
                        <Text type="secondary">東部、離島及其他地區</Text>
                      </p>
                    </Title>
                    {options(investigations[5]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "D") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="國名"
                                style={Object.assign({}, otherstyles, {
                                  width: "60px",
                                  height: "30px",
                                })}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[5]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                                key={index}
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                                key={index}
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                    <Divider orientation="left">境外(請填報工作國家別)</Divider>
                    {options(investigations[5]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "E") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="國名"
                                style={Object.assign({}, otherstyles, {
                                  width: "60px",
                                  height: "30px",
                                })}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[5]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                                key={index}
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                                key={index}
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                  </Radio.Group>
                </List.Item>
              </List>
            </TabPane>
            <TabPane
              tab={investigations[6]["tabname"]}
              key={investigations[6]["label"]}
              disabled={investigations[6]["disabled"]}
              style={{ width: "90%" }}
            >
              <List
                header={
                  <>
                    <Title level={4}>{investigations[6]["question"]}</Title>
                    <Text type="danger" underline>
                      {investigations[6]["description"]}
                    </Text>
                  </>
                }
                footer={
                  <>
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_jump(investigations[0]["label"])
                      }
                    >
                      上一題
                    </Button>{" "}
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_process(
                          investigations[6]["label"],
                          investigations[6]["answer"]
                        )
                      }
                    >
                      下一題
                    </Button>
                  </>
                }
              >
                <List.Item>
                  <Radio.Group
                    onChange={(e) =>
                      this.handle_ui_field_process(
                        "radio",
                        investigations[6]["label"],
                        "answer",
                        e
                      )
                    }
                  >
                    <Divider orientation="left">A.進修</Divider>
                    {options(investigations[6]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "A") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={Object.assign({}, otherstyles, {
                                  width: "150px",
                                  height: "30px",
                                })}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[6]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                                key={index}
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                                key={index}
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                    <Divider orientation="left">B.服役</Divider>
                    {options(investigations[6]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "B") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={Object.assign({}, otherstyles, {
                                  width: "150px",
                                  height: "30px",
                                })}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[6]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                                key={index}
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                                key={index}
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                    <Divider orientation="left">C.準備考試</Divider>
                    {options(investigations[6]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "C") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={Object.assign({}, otherstyles, {
                                  width: "150px",
                                  height: "30px",
                                })}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[6]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                                key={index}
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                                key={index}
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                    <Divider orientation="left">D.尋找工作中</Divider>
                    <Title level={5}>
                      <p>
                        <Text type="secondary">
                          D.1.到現在還在尋找工作的最大可能原因為何
                        </Text>
                      </p>
                    </Title>
                    {options(investigations[6]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "D1") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={Object.assign({}, otherstyles, {
                                  width: "150px",
                                  height: "30px",
                                })}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[6]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                                key={index}
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                                key={index}
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                    <Divider orientation="left"></Divider>
                    <Title level={5}>
                      <p>
                        <Text type="secondary">D.2.目前已花多久時間找工作</Text>
                      </p>
                    </Title>
                    <Radio.Group
                      onChange={(e) =>
                        this.handle_ui_field_process(
                          "radio",
                          investigations[6]["label"],
                          "supplementanswer",
                          e
                        )
                      }
                    >
                      {options(investigations[6]["label"]).map(
                        (item, index) => {
                          if (item["groupvalue"] === "D2") {
                            return (
                              <Radio
                                style={radioStyle}
                                value={item["choicevalue"]}
                                key={index}
                              >
                                {item["content"]}
                                {item["canselffill"] === "Y" ? (
                                  <Input
                                    placeholder="請說明"
                                    style={Object.assign({}, otherstyles, {
                                      width: "150px",
                                      height: "30px",
                                    })}
                                    onChange={(e) =>
                                      this.handle_ui_field_process(
                                        "input",
                                        investigations[6]["label"],
                                        "selffill",
                                        e
                                      )
                                    }
                                    key={index}
                                  />
                                ) : (
                                  ""
                                )}
                                {item["description"] ? (
                                  <Button
                                    type="link"
                                    shape="circle"
                                    icon={<QuestionCircleOutlined />}
                                    onClick={() =>
                                      this.handle_ui_open_notification(
                                        item["description"]
                                      )
                                    }
                                    key={index}
                                  ></Button>
                                ) : (
                                  ""
                                )}
                                {item["details"]
                                  ? item["details"].map((tag, index) => (
                                      <Tag key={index}>{tag}</Tag>
                                    ))
                                  : ""}
                              </Radio>
                            );
                          } else {
                            return true;
                          }
                        }
                      )}
                    </Radio.Group>
                    <Divider orientation="left">E.其他</Divider>
                    {options(investigations[6]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "E") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={Object.assign({}, otherstyles, {
                                  width: "150px",
                                  height: "30px",
                                })}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[6]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                                key={index}
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                                key={index}
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                  </Radio.Group>
                </List.Item>
              </List>
            </TabPane>
            <TabPane
              tab={investigations[7]["tabname"]}
              key={investigations[7]["label"]}
              disabled={investigations[7]["disabled"]}
              style={{ width: "90%" }}
            >
              <List
                header={
                  <>
                    <Title level={4}>{investigations[7]["question"]}</Title>
                    <Text type="danger" underline>
                      {investigations[7]["description"]}
                    </Text>
                  </>
                }
                footer={
                  <>
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_jump(investigations[5]["label"])
                      }
                    >
                      上一題
                    </Button>{" "}
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_process(
                          investigations[7]["label"],
                          investigations[7]["answer"]
                        )
                      }
                    >
                      下一題
                    </Button>
                  </>
                }
              >
                <List.Item>
                  <Radio.Group
                    onChange={(e) =>
                      this.handle_ui_field_process(
                        "radio",
                        investigations[7]["label"],
                        "answer",
                        e
                      )
                    }
                  >
                    {options(investigations[7]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "default") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <>
                                <Input
                                  placeholder="幾"
                                  style={Object.assign({}, otherstyles, {
                                    width: "50px",
                                  })}
                                  onChange={(e) =>
                                    this.handle_ui_field_process(
                                      "input",
                                      investigations[7]["label"],
                                      "selffill",
                                      e
                                    )
                                  }
                                  key={index}
                                />
                                月
                              </>
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                                key={index}
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                  </Radio.Group>
                </List.Item>
              </List>
            </TabPane>
            <TabPane
              tab={investigations[8]["tabname"]}
              key={investigations[8]["label"]}
              disabled={investigations[8]["disabled"]}
              style={{ width: "90%" }}
            >
              <List
                header={
                  <>
                    <Title level={4}>{investigations[8]["question"]}</Title>
                    <Text type="danger" underline>
                      {investigations[8]["description"]}
                    </Text>
                  </>
                }
                footer={
                  <>
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_jump(investigations[7]["label"])
                      }
                    >
                      上一題
                    </Button>{" "}
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_process(
                          investigations[8]["label"],
                          investigations[8]["answer"]
                        )
                      }
                    >
                      下一題
                    </Button>
                  </>
                }
              >
                <List.Item>
                  <Radio.Group
                    onChange={(e) =>
                      this.handle_ui_field_process(
                        "radio",
                        investigations[8]["label"],
                        "answer",
                        e
                      )
                    }
                  >
                    {options(investigations[8]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "default") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={otherstyles}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[8]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                                key={index}
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                                key={index}
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                  </Radio.Group>
                </List.Item>
              </List>
            </TabPane>
            <TabPane
              tab={investigations[9]["tabname"]}
              key={investigations[9]["label"]}
              disabled={investigations[9]["disabled"]}
              style={{ width: "90%" }}
            >
              <List
                header={
                  <>
                    <Title level={4}>{investigations[9]["question"]}</Title>
                    <Text type="danger" underline>
                      {investigations[9]["description"]}
                    </Text>
                  </>
                }
                footer={
                  <>
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_jump(investigations[8]["label"])
                      }
                    >
                      上一題
                    </Button>{" "}
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_process(
                          investigations[9]["label"],
                          investigations[9]["answer"]
                        )
                      }
                    >
                      下一題
                    </Button>
                  </>
                }
              >
                <List.Item>
                  <Radio.Group
                    onChange={(e) =>
                      this.handle_ui_field_process(
                        "radio",
                        investigations[9]["label"],
                        "answer",
                        e
                      )
                    }
                  >
                    {options(investigations[9]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "default") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={otherstyles}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[9]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                                key={index}
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                                key={index}
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                  </Radio.Group>
                </List.Item>
              </List>
            </TabPane>
            <TabPane
              tab={investigations[10]["tabname"]}
              key={investigations[10]["label"]}
              disabled={investigations[10]["disabled"]}
              style={{ width: "90%" }}
            >
              <List
                header={
                  <>
                    <Title level={4}>{investigations[10]["question"]}</Title>
                    <Text type="danger" underline>
                      {investigations[10]["description"]}
                    </Text>
                  </>
                }
                footer={
                  <>
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_jump(investigations[9]["label"])
                      }
                    >
                      上一題
                    </Button>{" "}
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_process(
                          investigations[10]["label"],
                          investigations[10]["answer"]
                        )
                      }
                    >
                      下一題
                    </Button>
                  </>
                }
              >
                <List.Item>
                  <Radio.Group
                    onChange={(e) =>
                      this.handle_ui_field_process(
                        "radio",
                        investigations[10]["label"],
                        "answer",
                        e
                      )
                    }
                  >
                    {options(investigations[10]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "default") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={otherstyles}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[10]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                                key={index}
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                                key={index}
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                  </Radio.Group>
                </List.Item>
              </List>
            </TabPane>
            <TabPane
              tab={investigations[11]["tabname"]}
              key={investigations[11]["label"]}
              disabled={investigations[11]["disabled"]}
              style={{ width: "90%" }}
            >
              <List
                header={
                  <>
                    <Title level={4}>{investigations[11]["question"]}</Title>
                    <Text type="danger" underline>
                      {investigations[11]["description"]}
                    </Text>
                  </>
                }
                footer={
                  <>
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_jump(investigations[10]["label"])
                      }
                    >
                      上一題
                    </Button>{" "}
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_process(
                          investigations[11]["label"],
                          investigations[11]["answer"]
                        )
                      }
                    >
                      下一題
                    </Button>
                  </>
                }
              >
                <List.Item>
                  <Checkbox.Group
                    onChange={(e) =>
                      this.handle_ui_field_process(
                        "checkbox",
                        investigations[11]["label"],
                        "answer",
                        e
                      )
                    }
                  >
                    {options(investigations[11]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "default") {
                        return (
                          <Checkbox
                            style={radioStyle}
                            label={item["content"]}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={Object.assign({}, otherstyles, {
                                  width: "150px",
                                  height: "30px",
                                })}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[11]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                                key={index}
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] !== "" ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                                key={index}
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Checkbox>
                        );
                      } else {
                        return true;
                      }
                    })}
                  </Checkbox.Group>
                </List.Item>
              </List>
            </TabPane>
            <TabPane
              tab={investigations[12]["tabname"]}
              key={investigations[12]["label"]}
              disabled={investigations[12]["disabled"]}
              style={{ width: "90%" }}
            >
              <List
                header={
                  <>
                    <Title level={4}>{investigations[12]["question"]}</Title>
                    <Text type="danger" underline>
                      {investigations[12]["description"]}
                    </Text>
                  </>
                }
                footer={
                  <>
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_jump(investigations[11]["label"])
                      }
                    >
                      上一題
                    </Button>{" "}
                    <Button
                      type="primary"
                      onClick={() =>
                        this.handle_ui_tab_process(
                          investigations[12]["label"],
                          investigations[12]["answer"]
                        )
                      }
                    >
                      下一題
                    </Button>
                  </>
                }
              >
                <List.Item>
                  <Radio.Group
                    onChange={(e) =>
                      this.handle_ui_field_process(
                        "radio",
                        investigations[12]["label"],
                        "answer",
                        e
                      )
                    }
                  >
                    <Divider orientation="left">A.有</Divider>
                    <p>
                      <Text disabled strong>
                        進修
                      </Text>
                    </p>
                    {options(investigations[12]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "A1") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={Object.assign({}, otherstyles, {
                                  width: "150px",
                                  height: "30px",
                                })}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[12]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                                key={index}
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                                key={index}
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                    <p>
                      <Text disabled strong>
                        準備考試或其他證照
                      </Text>
                    </p>
                    {options(investigations[12]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "A2") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={Object.assign({}, otherstyles, {
                                  width: "150px",
                                  height: "30px",
                                })}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[12]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                                key={index}
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                                key={index}
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                    <p>
                      <Text disabled strong>
                        其他
                      </Text>
                    </p>
                    {options(investigations[12]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "A3") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={Object.assign({}, otherstyles, {
                                  width: "150px",
                                  height: "30px",
                                })}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[12]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                                key={index}
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                                key={index}
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                    <Divider orientation="left">B.沒有</Divider>
                    {options(investigations[12]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "B") {
                        return (
                          <Radio
                            style={radioStyle}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={Object.assign({}, otherstyles, {
                                  width: "150px",
                                  height: "30px",
                                })}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[12]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                                key={index}
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] !== "" ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                                key={index}
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Radio>
                        );
                      } else {
                        return true;
                      }
                    })}
                  </Radio.Group>
                </List.Item>
              </List>
            </TabPane>
            <TabPane
              tab={investigations[13]["tabname"]}
              key={investigations[13]["label"]}
              disabled={investigations[13]["disabled"]}
              style={{ width: "90%" }}
            >
              <List
                header={
                  <>
                    <Title level={4}>{investigations[13]["question"]}</Title>
                    <Text type="danger" underline>
                      {investigations[13]["description"]}
                    </Text>
                  </>
                }
                footer={
                  <Button
                    type="primary"
                    onClick={() =>
                      this.handle_ui_tab_process(
                        investigations[13]["label"],
                        investigations[13]["answer"]
                      )
                    }
                  >
                    送出問卷
                  </Button>
                }
              >
                <List.Item>
                  <Checkbox.Group
                    onChange={(e) =>
                      this.handle_ui_field_process(
                        "checkbox",
                        investigations[13]["label"],
                        "answer",
                        e
                      )
                    }
                  >
                    {options(investigations[13]["label"]).map((item, index) => {
                      if (item["groupvalue"] === "default") {
                        return (
                          <Checkbox
                            style={radioStyle}
                            label={item["content"]}
                            value={item["choicevalue"]}
                            key={index}
                          >
                            {item["content"]}
                            {item["canselffill"] === "Y" ? (
                              <Input
                                placeholder="請說明"
                                style={Object.assign({}, otherstyles, {
                                  width: "150px",
                                  height: "30px",
                                })}
                                onChange={(e) =>
                                  this.handle_ui_field_process(
                                    "input",
                                    investigations[3]["label"],
                                    "selffill",
                                    e
                                  )
                                }
                                key={index}
                              />
                            ) : (
                              ""
                            )}
                            {item["description"] !== "" ? (
                              <Button
                                type="link"
                                shape="circle"
                                icon={<QuestionCircleOutlined />}
                                onClick={() =>
                                  this.handle_ui_open_notification(
                                    item["description"]
                                  )
                                }
                                key={index}
                              ></Button>
                            ) : (
                              ""
                            )}
                            {item["details"]
                              ? item["details"].map((tag, index) => (
                                  <Tag key={index}>{tag}</Tag>
                                ))
                              : ""}
                          </Checkbox>
                        );
                      } else {
                        return true;
                      }
                    })}
                  </Checkbox.Group>
                </List.Item>
              </List>
            </TabPane>
            <TabPane
              tab={investigations[14]["tabname"]}
              key={investigations[14]["label"]}
              disabled={investigations[14]["disabled"]}
              style={{ width: "90%" }}
            >
              <List
                header={
                  isWork === false ? (
                    <>
                      <Title level={4}>謝謝您的填答</Title>
                    </>
                  ) : (
                    <>
                      <Title level={4}>
                        謝謝您的填答，
                        <span style={{ color: "Red" }}>
                          若您願意提供公司詳細資料，有助於母校提供您工作上的協助
                        </span>
                      </Title>
                    </>
                  )
                }
              >
                <List.Item>
                  <form onSubmit={this.handleSubmit}>
                    <div className="form-row">
                      <div className="col-lg-3">
                        <div className="form-group">
                          <label>工作型態</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="JobType"
                            id="JobType"
                            placeholder="全職/兼職"
                            defaultValue={JobType}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-5">
                        <div className="form-group">
                          <label>工作職稱</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            ame="JobTitle"
                            id="JobTitle"
                            nplaceholder="家管/負責人/經理/業務...."
                            defaultValue={JobTitle}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="form-group">
                          <label>第一份薪水金額</label>
                          <input
                            type="number"
                            className="form-control text-primary"
                            name="JobFirstSalary"
                            id="JobFirstSalary"
                            placeholder="僅填數字"
                            defaultValue={JobFirstSalary}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="form-group">
                          <label>當前薪水金額</label>
                          <input
                            type="number"
                            className="form-control text-primary"
                            name="CurrentSalary"
                            id="CurrentSalary"
                            placeholder="僅填數字"
                            defaultValue={CurrentSalary}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-lg-5">
                        <div className="form-group">
                          <label>公司名稱</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="JobCompany"
                            id="JobCompany"
                            placeholder="公司名稱"
                            defaultValue={JobCompany}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg">
                        <div className="form-group">
                          <label>隸屬部門</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="JobDepartment"
                            id="JobDepartment"
                            placeholder="部門名稱"
                            defaultValue={JobDepartment}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-lg-3">
                        <div className="form-group">
                          <label>公司電話</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="JobTelephone"
                            id="JobTelephone"
                            placeholder="公司電話"
                            defaultValue={JobTelephone}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="form-group">
                          <label>傳真電話</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="JobFax"
                            id="JobFax"
                            placeholder="傳真電話"
                            defaultValue={JobFax}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg">
                        <div className="form-group">
                          <label>公司地址</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="JobAddress"
                            id="JobAddress"
                            placeholder=" 公司地址"
                            defaultValue={JobAddress}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-lg-5">
                        <div className="form-group">
                          <label>雇主姓名</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="JobBossName"
                            id="JobBossName"
                            placeholder="雇主(或主管)姓名"
                            defaultValue={JobBossName}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg">
                        <div className="form-group">
                          <label>雇主電子郵件</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="JobBossEmail"
                            id="JobBossEmail"
                            placeholder="雇主(或主管)電子郵件"
                            defaultValue={JobBossEmail}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                      <input
                        type="submit"
                        value="送出"
                        className="btn btn-warning btn-block btn-sm"
                      />
                    </div>
                  </form>
                </List.Item>
              </List>
            </TabPane>
          </Tabs>
        ) : (
          <Alert message="非滿畢業一年調查對象" type="warning" closable />
        )}
        <Modal
          destroyOnClose={true}
          title="基本資料調查"
          visible={isShowEditAlumniInfoModal}
          width={1000}
          onOk={() => {
            this.setState({
              isShowEditAlumniInfoModal: false,
              isLocked: false,
            });
          }}
          onCancel={() => {
            this.setState({ isShowEditAlumniInfoModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <AdumniModifyModal alumni={item} />
        </Modal>
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(SurveyFirstYear);
